import { Heading, Text } from '@ad-lucy/ui';
import styled from 'styled-components';

export const StyledView = styled.div`
  height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme?.spacing?.lg};

  max-width: 1024px;
`;

export const Title = styled(Heading)`
  color: ${({ theme }) => theme?.colors?.gray?._900};
  font-size: 60px;
  letter-spacing: -1.34px;
  line-height: 72px;
  text-align: center;
`;

export const Subtitle = styled(Text)`
  text-align: center;
  white-space: pre;
  color: ${({ theme }) => theme?.colors?.gray?._500};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme?.spacing?.sm};
`;
